export const gossipLiveUpdates = [
  {
    time: "10:12",
    title: "巡演加场开票十分钟售罄",
    detail: "主办方昨晚宣布追加一场，上午十点开票，页面显示全部售罄，抢票话题同步升温。",
    categorySlug: "star-news",
    important: true,
  },
  {
    time: "09:48",
    title: "联名产品补货传闻流出",
    detail: "有渠道商透露第二批数量有限，官方暂未回应，二手价格仍在波动。",
    categorySlug: "hot-topics",
    important: false,
  },
  {
    time: "09:20",
    title: "杀青宴同框画面持续发酵",
    detail: "原始视频被反复二次剪辑，话题阅读量两小时内翻倍，双方团队仍未回应。",
    categorySlug: "entertainment-gossip",
    important: true,
  },
  {
    time: "08:50",
    title: "音乐节直播音质讨论集中出现",
    detail: "现场与线上评价分化，讨论焦点落在混音处理上，演出方暂未说明。",
    categorySlug: "music-live",
    important: false,
  },
  {
    time: "08:05",
    title: "综艺录制花絮被重新解读",
    detail: "一段未播出的候场画面被剪短传播，节目组未就此单独回应。",
    categorySlug: "entertainment-gossip",
    important: false,
  },
  {
    time: "07:45",
    title: "悬疑剧更新过半口碑分化",
    detail: "评分结构两极，讨论从剧情转向叙事节奏，后期走向成为关键变量。",
    categorySlug: "film-tv",
    important: true,
  },
  {
    time: "06:30",
    title: "话题词条凌晨加速冲榜",
    detail: "词条上升曲线陡峭，传播路径指向几个高互动账号的首轮扩散。",
    categorySlug: "hot-topics",
    important: true,
  },
  {
    time: "05:15",
    title: "新专辑第二组物料预告释出",
    detail: "官方账号放出剪影图与一行文案，未透露曲风信息，评论仍在讨论造型方向。",
    categorySlug: "star-news",
    important: false,
  },
  {
    time: "03:40",
    title: "档期调整公告再次出现",
    detail: "一部原定新片宣布延后一周上映，片方称出于制作优化考虑。",
    categorySlug: "film-tv",
    important: false,
  },
  {
    time: "01:20",
    title: "短视频挑战赛参与量破新高",
    detail: "多个品牌账号加入改编，话题跳出原有兴趣圈层，参与数量仍在上升。",
    categorySlug: "hot-topics",
    important: false,
  },
];